<div class="layout-row full-height">
  <div class="flex layout-column">
    <div class="layout-row layout-align-start-center margin-bottom-5">
      <bz-icon class="margin-right-5" [icon]="icons.address"></bz-icon>
      <span class="text-ellipsis br-body-2" container="body" [ngbTooltip]="task().address | bringozAddress">{{ task().address | bringozAddress }}</span>
    </div>

    @if (task().contact?.fullName) {
      <div class="layout-row layout-align-start-center margin-bottom-5 threepl-task-location">
        @switch (task().locationDetails?.locationType) {
          @case (locationTypes.ACCOUNT) {
            <span container="body" [ngbTooltip]="task().contact.fullName"><bz-icon class="margin-right-5" [icon]="icons.account"></bz-icon></span>
            <app-demand-account-link class="text-ellipsis" [account]="locationRef()" [isAllowCopyButton]="true"></app-demand-account-link>
          }
          @case (locationTypes.DEPOT) {
            <span container="body" [ngbTooltip]="task().contact.fullName"><bz-icon class="margin-right-5" [icon]="icons.depot"></bz-icon></span>
            <app-depot-link class="text-ellipsis" [depot]="locationRef()"></app-depot-link>
            <bz-copy-button class="threepl-task-copy" appBringozIdGenerator="threepl-service-task-depot-copy-button" [text]="task().contact.fullName"></bz-copy-button>
          }
          @case (locationTypes.CUSTOMER) {
            <span container="body" [ngbTooltip]="task().contact.fullName"><bz-icon class="margin-right-5" [icon]="icons.customer"></bz-icon></span>
            <app-customer-link class="text-ellipsis" [customer]="task().contact"></app-customer-link>
            <bz-copy-button class="threepl-task-copy" appBringozIdGenerator="threepl-service-task-customer-copy-button" [text]="task().contact.fullName"></bz-copy-button>
          }
          @case (locationTypes.CUSTOM) {
            <bz-icon class="margin-right-5" [icon]="icons.custom"></bz-icon>
            <span class="br-body-2 margin-right-10 text-ellipsis" data-sl="mask" container="body" [ngbTooltip]="task().contact.fullName">{{ task().contact.fullName }}</span>
          }
        }
      </div>
    }

    @if (task().contact?.businessName) {
      <div class="layout-row layout-align-start-center margin-bottom-5">
        <bz-icon class="margin-right-5" [icon]="icons.business"></bz-icon>
        <span class="text-ellipsis br-body-2">{{ task().contact.businessName }}</span>
      </div>
    }
    @if (task().contact?.phoneNo) {
      <div class="layout-row layout-align-start-center margin-bottom-5">
        <bz-icon class="margin-right-5" [icon]="icons.phone"></bz-icon>
        <span class="text-ellipsis br-body-2">{{ task().contact.phoneNo }}</span>
      </div>
    }
    @if (task().eta) {
      <div class="layout-row layout-align-start-center margin-bottom-5">
        <bz-icon class="margin-right-5" [icon]="icons.eta"></bz-icon>
        <span class="text-ellipsis br-body-2">{{ task() | bringozTime: 'eta' }}</span>
      </div>
    }
    @if (task().etd) {
      <div class="layout-row layout-align-start-center margin-bottom-5">
        <bz-icon class="margin-right-5" [icon]="icons.etd"></bz-icon>
        <span class="text-ellipsis br-body-2">{{ task() | bringozTime: 'etd' }}</span>
      </div>
    }
    <div class="layout-row layout-align-start-center">
      <bz-icon class="margin-right-5" [icon]="icons.window"></bz-icon>
      <span class="br-body-2">{{ task() | timeWindow }}</span>
      <!-- ui-fallback: time-window tooltip stays an admin component -->
      <app-bringoz-time-window-tooltip [notBefore]="task().notBefore" [notAfter]="task().notAfter"
                                       [timeZoneId]="task().address?.zoneIdName" [configZoneId]="configZoneId">
      </app-bringoz-time-window-tooltip>
    </div>
  </div>
  <div class="flex layout-column"></div>
</div>
